import { LoaderActions } from '@store/loaders'
import {
  ApiKeyRevokedNotification,
  ErrorNotification,
} from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { ApiKeysService } from '@/services/apiKeys'
import { type ApiKeysActions, InternalApiKeysActions } from '../actions'

export function* revokeApiKey({
  payload: { id },
}: ReturnType<typeof ApiKeysActions.revoke>) {
  sendGtmEvent(GtmTriggerName.API_KEY_REVOKE)

  yield put(LoaderActions.set(id))

  try {
    yield call(ApiKeysService.revoke, id)

    yield put(InternalApiKeysActions.remove(id))
    yield put(ApiKeyRevokedNotification)
  } catch (error) {
    console.error('Failed to revoke API key', error)

    yield put(ErrorNotification('Failed to revoke API key'))
  } finally {
    yield put(LoaderActions.unset(id))
  }
}
